import React from 'react'

import SessionContext from '../contexts/SessionContext'

const useSession = () => React.useContext(SessionContext)

export default useSession
